class SeqBuffer {
  private chunks = new Map<number, string>();

  add(seq: number, content: string): string {
    this.chunks.set(seq, content);

    return this.toString();
  }

  toString(): string {
    return [...this.chunks.keys()]
      .sort((a, b) => a - b)
      .map((seq) => this.chunks.get(seq))
      .join('');
  }
}

class SeqBufferRegistry {
  private buffers = new Map<string, SeqBuffer>();

  add(messageId: string, seq: number, content: string): string {
    let buffer = this.buffers.get(messageId);

    if (!buffer) {
      buffer = new SeqBuffer();
      this.buffers.set(messageId, buffer);
    }

    return buffer.add(seq, content);
  }

  release(messageId: string): void {
    this.buffers.delete(messageId);
  }

  clear(): void {
    this.buffers.clear();
  }
}

export { SeqBuffer, SeqBufferRegistry };
